<article
  class="core-ui-media-card"
  [attr.aria-busy]="loading"
>
  <ng-container *ngIf="!loading; else skeletonCard">
    <button
      type="button"
      class="core-ui-media-card__surface"
      [class.has-image]="!!imageUrl"
      [attr.aria-label]="ariaLabel || 'Ver ' + title"
      (click)="selected.emit()"
    >
      <img
        *ngIf="imageUrl"
        [src]="imageUrl"
        [alt]="imageAlt"
        [class.is-image-loading]="imageLoading"
        (load)="onImageSettled()"
        (error)="onImageSettled()"
      />

      <span class="core-ui-media-card__gradient" aria-hidden="true"></span>

      <span
        *ngIf="statusLabel"
        class="core-ui-media-card__status"
        [class.is-active]="status === 'active'"
      >
        <span class="core-ui-media-card__status-indicator" aria-hidden="true"></span>
        <span class="core-ui-media-card__status-label">{{ statusLabel }}</span>
      </span>

      <span class="core-ui-media-card__information">
        <strong>{{ title }}</strong>
        <span *ngIf="metadata">{{ metadata }}</span>
      </span>
    </button>

    <core-ui-dropdown-menu
      *ngIf="actions.length"
      class="core-ui-media-card__actions"
      [ariaLabel]="actionsAriaLabel"
      [triggerAriaLabel]="actionsAriaLabel + ' de ' + title"
      [menuWidth]="actionsMenuWidth"
      placement="bottom-left"
      (actionSelected)="actionSelected.emit($event)"
    >
      <core-ui-dropdown-menu-item
        *ngFor="let action of actions"
        [id]="action.id"
        [label]="action.label"
        [icon]="action.icon"
        [iconSize]="action.iconSize ?? '16.6'"
        [variant]="action.destructive ? 'danger' : 'default'"
        [disabled]="!!action.disabled"
        [separatorBefore]="!!action.separatorBefore"
      ></core-ui-dropdown-menu-item>
    </core-ui-dropdown-menu>
  </ng-container>
</article>

<ng-template #skeletonCard>
  <div class="core-ui-media-card__surface is-loading" aria-hidden="true">
    <core-ui-skeleton
      class="core-ui-media-card__skeleton"
      width="100%"
      height="100%"
      radius="20px"
    ></core-ui-skeleton>
  </div>
</ng-template>
